import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const REPORT_ACTIONS_QUERY_KEY = "reportActions";

/** Refetches the advisor's actions inbox after one is created or moved. */
export const useInvalidateReportActions = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [REPORT_ACTIONS_QUERY_KEY]
    });
  }, [queryClient]);
};
